// Pure client navigation state: which cook session the fullscreen cooking screen
// is showing. Single-device, disposable — localStorage (not Dexie/server). Spec §7.4.
const KEY = "rv.focusedSessionId";

export function getFocusedSessionId(): string | null {
  try {
    const v = localStorage.getItem(KEY);
    return v && v.startsWith("sess_") ? v : null;
  } catch {
    return null;
  }
}

export function setFocusedSessionId(id: string): void {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* private mode / quota — focus state is best-effort */
  }
}

export function clearFocusedSessionId(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
